export const ConsumerPhoneValidationSectionFormUat = {
  field: 'workflow.consumerPhoneValidation.validatePhoneNumber.field'
}
